import { FC } from "react";
import TermsAndConditions from "~/modules/terms-and-conditions/pages/terms-and-conditions";
import { termsAndConditionsLoader } from "~/loaders/terms-and-conditions.loader";

export { termsAndConditionsLoader as loader };

interface IndexProps {}

const Index: FC<IndexProps> = () => {
  return <TermsAndConditions />;
};

export default Index;
